import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

const playerSwapSelectedPlayerSelector = createSelector(
  get('playerSwap.selectedSlate'),
  get('playerSwap.selectedPosition'),
  get('playerSwap.selectedPlayerId'),
  (slate, selectedPosition, playerId) => {
    const player = get(['positions', selectedPosition, 'players', playerId], slate);

    return player
      ? {
          ...player,
          teamAbbr: player.isHome ? player.homeAbbr : player.awayAbbr
        }
      : undefined;
  }
);

export default playerSwapSelectedPlayerSelector;
